<div class="ec-economics-redistributed-container" fxLayout="column" fxLayoutGap="15px"
     *appVar="hierarchyEntity|async as entity">

    <!-- top bar -->
    <app-filter-bar
            [showNullData]="showNullData"
            [config]="billingPeriodCfg"
            [billingPeriod]="billingPeriod"
            [useFilter]="true"
            [showGSEBtn]="false"
            [templateIsDownloading]="templateIsDownloading"
            (billingPeriodEventEmitter)="onChangeBillingPeriod($event)">
        <!--            [response]="summary"-->
        <!--            (exportDataEventEmitter)="exportEconomicsToExcel()"-->
    </app-filter-bar>

    <!-- info section -->
    <ng-container *ngIf="entity && isViewable(entity); else unviewableEntity">
        <ng-container *ngIf="response">

            <!-- consolidated label label -->
            <div fxLayout="row" fxLayoutAlign="end center">
                <app-consolidation-info-bar *ngIf="!inactiveEc && !futureEc"
                                            [billingPeriod]=billingPeriodSubj.asObservable()
                                            [timeZone]="timeZone"
                                            [summaryResponse]=summaryResponseSubject.asObservable()>
                </app-consolidation-info-bar>
            </div>

            <!-- tile section -->
            <div fxLayout="row" fxLayoutAlign="space-between stretch">

                <!-- absorption redistributed section -->
                <div fxLayout="column" fxFlex="15" fxLayoutGap="30px" class="panel p-16">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                        <div class="txt-h-18-7">{{ absorptionRedistributedLabel|i18n }}</div>
                        <app-icon icon-color-h name="fas-info-circle"
                                  [title]="'Incentive effectively redistributed between members'|i18n">
                        </app-icon>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                        <div [ngClass]="response.gse ? 'txt-b-30-7' : 'txt-h-30-7' ">
                            {{ keepYourSecrets ? '-' : (response.incentivation.redistributed_revenue|niceValue:'€':2) }}
                        </div>
                        <app-icon *ngIf="showMembersWarning"
                                  icon-color-w name="fas-exclamation-triangle"
                                  [title]="('The total number of active POD varied during the selected time range affecting the incentive computation for each POD.'|i18n) + ' ' +
                                           ('To get details on the stay of active POD in the community you can refer to the Subjects section.'|i18n)">
                        </app-icon>
                    </div>
                </div>

                <div fxFlex="1"></div>

                <!-- algorithm section -->
                <div *ngIf="response" fxLayout="column" fxFlex="25" class="panel p-16">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                        <div class="txt-h-18-7">{{ 'Redistribution algorithm'|i18n }}</div>
                        <app-icon icon-color-h name="fas-info-circle"
                                  [title]="'Calculation method for allocating the apportionable withdrawal among the withdrawing utilities.'|i18n">
                        </app-icon>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="mt-30">
                        <app-icon icon-color-w name="fas-exclamation-triangle"
                                  *ngIf="response && rows && !showNullData &&
                                    (isNoAlgorithm || !response?.redistribution) &&
                                    this.isWholeYear && isUpdatable(entity) && this.performanceTotalPods > 0 && !this.communityNotConfigured"
                                  [title]="'Please select a redistribution algorithm'|i18n">
                        </app-icon>
                        <app-icon icon-color-w name="fas-exclamation-triangle"
                                  *ngIf="higherRedistributableWarning"
                                  [title]="'The current redistributable amount doesn\'t cover the required sum from the configuration file'|i18n">
                        </app-icon>
                        <div class="txt-h-16-4">
                            {{ ((response?.redistribution?.algorithm || '')|redistributedAlgorithm|i18n) || '-' }}
                        </div>
                        <button app-primary-button (click)="onClickEditAlgorithm()"
                                [disabled]="canChooseAlgorithm(entity)">
                            <app-icon name="fal-pen" class="ml-12"></app-icon>
                        </button>
                        <button app-ghost-button *ngIf="isDefined(response?.redistribution?.algorithm)"
                                (click)="onClickIncentiveCalculation(response?.redistribution?.algorithm)"
                                [disabled]="(response?.redistribution?.algorithm !== ALGORITHM_VAI &&
                                response?.redistribution?.algorithm !== ALGORITHM_CAPPED_VAI &&
                                response?.redistribution?.algorithm !== ALGORITHM_FANO &&
                                response?.redistribution?.algorithm !== ALGORITHM_CONDO_OLD &&
                                response?.redistribution?.algorithm !== ALGORITHM_CONDO_NEW &&
                                response?.redistribution?.algorithm !== ALGORITHM_THOUSANDTH &&
                                response?.redistribution?.algorithm !== ALGORITHM_MIXED)">
                            <app-icon name="fas-info-circle" class="ml-12"></app-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="isWholeYear" fxFlex="1"></div>

                <!-- TIP exceeding quote part -->
                <div *ngIf="isWholeYear && isDefined(strategyFeatures) && strategyFeatures.features[ECEconomicsFeatures.SURPLUS_PREMIUM_RATE]"
                     fxLayout="column" fxLayoutAlign="center" fxLayoutGap="12px" class="panel p-16" fxFlex="25">
                    <div fxLayout="row" fxFlex="34" fxLayoutGap="12px">
                        <div class="txt-h-18-7">{{ 'Exceeding amount'|i18n }}</div>
                        <app-icon icon-color-h name="fas-info-circle"
                                  [title]="'Eventual amount of premium incentive that exceeds the incentiveable shared energy threshold. This should be set aside or allocated to private absorbing members in proportion to the incentive they already get.'|i18n"></app-icon>
                    </div>
                    <div fxLayout="row" fxFlex="33" class="txt-p-12-4">
                        {{ ('TIP allocated to enterprises due to plants redistribution and absorption - Maximum TIP redistributable for companies'|i18n) + ':' }}
                    </div>
                    <div fxLayout="row" fxFlex="33" fxLayoutAlign="space-between center">
                        <div class="txt-h-16-7" fxLayout="row" fxFlex="25">
                            {{
                                showNullData || !isDefined(response?.surplus_premium_rate) &&
                                !isDefined(response?.surplus_premium_rate?.surplus_quota) ? '€ -' :
                                    (response.surplus_premium_rate.surplus_quota|niceValue: '€':2)
                            }}
                        </div>
                        <!--<div *ngIf="!response.surplus_premium_rate.has_surplus" fxLayout="row" fxLayoutAlign="space-around center"-->
                        <!--     class="txt-s-14-4 color-accent" fxLayoutGap="8px">-->
                        <!--    <app-icon name="fal-check-circle"></app-icon>-->
                        <!--    <div>{{'No excess'|i18n}}</div>-->
                        <!--</div>-->
                        <div *ngIf="response.surplus_premium_rate.scope === ECSurplusPremiumRateScope.ALLOCATED"
                             fxLayout="row" fxLayoutAlign="space-around center" class="txt-s-14-4" fxLayoutGap="8px">
                            <app-icon name="fal-arrow-right"></app-icon>
                            <app-icon name="fal-piggy-bank"></app-icon>
                            <div>{{ 'Saved as fund'|i18n }}</div>
                        </div>
                        <div *ngIf="response.surplus_premium_rate.scope === ECSurplusPremiumRateScope.CONSUMER_REDISTRIBUTED"
                             fxLayout="row" fxLayoutAlign="space-around center" class="txt-s-14-4" fxLayoutGap="8px">
                            <app-icon name="fal-arrow-right"></app-icon>
                            <app-icon name="fal-plug"></app-icon>
                            <div>{{ 'Intended for non-enterprise absorptions'|i18n }}</div>
                        </div>
                        <div *ngIf="response.surplus_premium_rate.scope === ECSurplusPremiumRateScope.UNDEFINED"
                             fxLayout="row" fxLayoutAlign="space-around center"
                             class="txt-s-14-4" fxLayoutGap="8px">
                            <app-icon name="fas-exclamation-triangle" icon-color-w
                                      [title]="'Use the algorithm configuration form to choose where to allocate this amount.'|i18n"></app-icon>
                            <app-icon name="fal-arrow-right"></app-icon>
                            <div>{{ 'To be allocated'|i18n }}</div>
                        </div>
                    </div>
                </div>

                <div *ngIf="ecMode === ECMode.BASE || ecMode === ECMode.HYBRID" fxFlex="1"></div>

                <!-- POD count section -->
                <div *ngIf="ecMode === ECMode.BASE || ecMode === ECMode.HYBRID" fxLayout="column" fxFlex="14"
                     fxLayoutAlign="center" fxLayoutGap="30px" class="panel p-16">
                    <div *ngIf="ecMode === ECMode.HYBRID"
                         fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="ml-10">
                        <app-icon icon-color-s name="fal-radar"></app-icon>
                        <div class="txt-s-16-7">{{ 'Monitored PODs'|i18n }}</div>
                        <div class="txt-ec-16-7">{{ response.performance.field_pods || '-' }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="ml-10">
                        <app-icon icon-color-s name="fal-chart-network"></app-icon>
                        <div class="txt-s-16-7">{{ 'Statistical PODs'|i18n }}</div>
                        <div class="txt-ec-16-7">{{ response.performance.statistical_pods || '-' }}</div>
                    </div>
                </div>

                <div *ngIf="ecMode === ECMode.ADVANCED || ecMode === ECMode.HYBRID" fxFlex="1"></div>

                <!-- POD performance section -->
                <div *ngIf="ecMode === ECMode.ADVANCED || ecMode === ECMode.HYBRID" fxLayout="column" fxFlex="30"
                     fxLayoutGap="30px" class="panel p-16">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <app-icon icon-color-h name="fal-users" class="small-icon"></app-icon>
                        <div class="txt-h-18-7">{{ 'Monitored PODs sharing performance'|i18n }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px">
                            <div class="txt-s-16-7">{{ 'Good'|i18n }}:</div>
                            <div class="txt-acc-16-7">{{ response.performance.field_performance.good.count }}</div>
                        </div>
                        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px">
                            <div class="txt-s-16-7">{{ 'Medium'|i18n }}:</div>
                            <div class="txt-w-16-7">{{ response.performance.field_performance.medium.count }}</div>
                        </div>
                        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px">
                            <div class="txt-s-16-7">{{ 'Bad'|i18n }}:</div>
                            <div class="txt-a-16-7">{{ response.performance.field_performance.bad.count }}</div>
                        </div>
                    </div>
                </div>
                <div fxFlex></div>
            </div>


        </ng-container>
    </ng-container>
    <!-- end info section -->

    <!-- table section -->
    <ng-container *ngIf="!inactiveEc && !futureEc">
        <div fxLayout="column" class="table-back" *appVar="rows|async as rows">

            <!--   TODO     -->
            <!-- search bar -->
            <!--        <div app-input-container class="find-member-container" fxFlex="none">-->
            <!--            <input app-input autocomplete="off"-->
            <!--                   class="find-member txt-s-16-4"-->
            <!--                   [(ngModel)]="searchText"-->
            <!--                   (ngModelChange)="onClickSearchText()"-->
            <!--                   [spellcheck]="false" [placeholder]="'Search by name'|i18n">-->
            <!--            <app-icon *ngIf="searchText && searchText.length>0" name="fal-times" class="right-symbol clear"-->
            <!--                      (click)="onClickClearSearchText()">-->
            <!--            </app-icon>-->
            <!--            <svg *ngIf="!searchText || searchText.length===0" xmlns="http://www.w3.org/2000/svg"-->
            <!--                 viewBox="0 0 512 512"-->
            <!--                 class="right-symbol mag-glass">-->
            <!--                &lt;!&ndash;! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. &ndash;&gt;-->
            <!--                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>-->
            <!--            </svg>-->
            <!--        </div>-->


            <!-- table -->
            <ng-container *ngIf="response && rows; else loadingEconomics">
                <ng-container *ngIf="rows.total > 0">
                    <table mat-table
                           app-table
                           [dataSource]="rows.members"
                           multiTemplateDataRows
                           class="member-table">

                        <!-- members cell -->
                        <ng-container matColumnDef="members">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <app-icon icon-color-h name="fal-users" class="small-icon"></app-icon>
                                    <div class="txt-h-16-7">{{ 'Members'|i18n }}</div>
                                </div>
                            </th>
                            <ng-container *ngIf="!isCondomNewStrategy">
                                <td mat-cell *matCellDef="let row">
                                    <div class="txt-p-16-4 members-box" *ngIf="!row.pod">
                                        {{ row.subjectName }}
                                    </div>
                                    <div *ngIf="row.pod" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="4px">
                                        <div class="txt-p-16-7">{{ row.pod.pod }}</div>
                                        <div *ngIf="getLandRegistryDescription(row, row.pod.pod) as landRegDesc"
                                             class="txt-p-16-4">
                                            {{ landRegDesc }}
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container *ngIf="isCondomNewStrategy">
                                <td mat-cell *matCellDef="let row">
                                    <!-- property unit -->
                                    <div *ngIf="isPropertyUnitRow(row)" class="txt-p-16-4 members-box">
                                        {{ row.propertyUnit.name }}
                                    </div>
                                    <!-- member and pod -->
                                    <div *ngIf="isPodRow(row) || isAlsoMemberRow(row)" fxLayout="column" fxLayoutAlign="center center"
                                         fxLayoutGap="4px">
                                        <div *ngIf="isAlsoMemberRow(row)" class="txt-p-16-7">
                                            {{ row.subjectName }}
                                        </div>
                                        <div *ngIf="isPodRow(row)" class="txt-p-16-4">
                                            {{ row.pod.pod }}
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                        </ng-container>

                        <!-- Roles - only for ALGORITHM_CONDO_NEW -->
                        <ng-container *ngIf="isCondomNew" matColumnDef="pod_roles">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Role'|i18n }}</div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="row.roles?.length" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                    <div *ngIf="row.roles.includes(ECMemberRelationType.HOLDER)"
                                         class="chip pod-holder"
                                         fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
                                        <app-icon name="fal-lightbulb"></app-icon>
                                        <span class="text">{{ mkRoleName(ECMemberRelationType.HOLDER, row.roles.length > 1)|i18n }}</span>
                                    </div>
                                    <div *ngIf="row.roles.includes(ECMemberRelationType.OWNER)"
                                         class="chip pod-owner"
                                         fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
                                        <app-icon name="fal-key"></app-icon>
                                        <span class="text">{{ mkRoleName(ECMemberRelationType.OWNER, row.roles.length > 1)|i18n }}</span>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- personal sharing cell -->
                        <ng-container matColumnDef="personal_sharing">
                            <th mat-header-cell *matHeaderCellDef [ngClass]="{'width-15': algorithm === ALGORITHM_MIXED}">
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Personal sharing'|i18n }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="'POD\'s absorption that became shared energy on its total absorption.'|i18n">
                                    </app-icon>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div fxLayoutAlign="center center" *ngIf="row.pod">
                                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                                         [ngClass]="getPersonalSharingCellClass(row.pod)">
                                        <app-icon *ngIf="isDefined(row.pod.incentivation.score) && !keepYourSecrets"
                                                  [ngClass]="getPersonalSharingCellIcon(row.pod)"
                                                  [name]="row.pod.data_source === ECPodDataSource.FIELD ?
                                                      (row.pod.incentivation.performance|performanceIcon) : 'fal-chart-network'">
                                        </app-icon>
                                        <div class="txt-p-14-4">
                                            {{ keepYourSecrets ? '-' : row.pod.incentivation.score * 100|niceValue:'%' }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- condominium thousandths cell - only for ALGORITHM_THOUSANDTH -->
                        <ng-container *ngIf="algorithm === ALGORITHM_THOUSANDTH" matColumnDef="thousandths">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <app-icon icon-color-h name="fal-building"></app-icon>
                                    <div class="txt-h-16-7">{{ 'Condominium thousandths'|i18n }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="('Thousandths value related to the member\'s POD by contract of property ownership'|i18n)">
                                    </app-icon>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="row.pod && row.pod.redistribution" fxLayoutAlign="center"
                                     class="txt-p-16-4">
                                    {{ isDefined(row.pod.redistribution[THOUSANDTHS]) && !keepYourSecrets ? (row.pod.redistribution[THOUSANDTHS] + '/1000') : '-' }}
                                </div>
                            </td>
                        </ng-container>

                        <!-- absorption/thousandths cell - only for ALGORITHM_CONDO_NEW -->
                        <ng-container *ngIf="isCondomNew" matColumnDef="absorption_or_thousandths">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Absorption or thousandths'|i18n }}</div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <!-- owner member -->
                                <div *ngIf="isOnlyMemberRow(row)" fxLayoutAlign="center">
                                    <div *ngIf="row.propertyUnit?.redistribution && !row.propertyUnit.seu" fxLayout="row"
                                         fxLayoutAlign="space-between center" fxLayoutGap="20px" class="txt-p-16-4">
                                        <div>
                                            <app-icon name="fal-building" class="mr-8"></app-icon>
                                            {{ isDefined(row.propertyUnit.redistribution[THOUSANDTHS]) && !keepYourSecrets ? ((row.propertyUnit.redistribution[THOUSANDTHS]|niceValue:null:3) + '/1000') : '-' }}
                                        </div>
                                        <div *ngIf="isDefined(row.propertyUnit.redistribution[THOUSANDTHS]) && !keepYourSecrets">
                                            {{ (row.propertyUnit.redistribution[THOUSANDTHS] / 10)|niceValue:'%':0 }}
                                        </div>
                                    </div>
                                    <div *ngIf="row.propertyUnit.seu"
                                         fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="txt-p-16-4">
                                        <div>
                                            <app-icon name="fal-plug" class="mr-8"></app-icon>
                                            {{ isDefined(row.propertyUnit.seu_absorbed_energy) && !keepYourSecrets ? (row.propertyUnit.seu_absorbed_energy|niceValue:'kWh') : '-' }}
                                        </div>
                                        <div *ngIf="isDefined(row.propertyUnit.seu_absorbed_energy) && isDefined(response.absorbed_energy) && response.absorbed_energy > 0 && !keepYourSecrets">
                                            {{ (row.propertyUnit.seu_absorbed_energy / response.absorbed_energy)|niceValue:'%' }}
                                        </div>
                                    </div>
                                </div>
                                <!-- pod -->
                                <!-- absorbed energy shown for SEU POD -->
                                <div *ngIf="row.pod && (row.roles.includes(ECMemberRelationType.HOLDER) || row.pod.seu)"
                                     fxLayoutAlign="center">
                                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="txt-p-16-4">
                                        <div>
                                            <app-icon name="fal-plug" class="mr-8"></app-icon>
                                            {{ isDefined(row.pod.absorbed_energy) && !keepYourSecrets ? (row.pod.absorbed_energy|niceValue:'kWh') : '-' }}
                                        </div>
                                        <div *ngIf="isDefined(row.pod.absorbed_energy) && isDefined(response.absorbed_energy) && response.absorbed_energy > 0 && !keepYourSecrets">
                                            {{ (row.pod.absorbed_energy / response.absorbed_energy)|niceValue:'%' }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- energy sharing cell - only for ALGORITHM_VAI or ALGORITHM_CAPPED_VAI -->
                        <ng-container *ngIf="algorithm === ALGORITHM_VAI || algorithm === ALGORITHM_CAPPED_VAI"
                                      matColumnDef="energy_sharing">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Per capita energy sharing'|i18n }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="'Weight of POD absorption on total community sharing.'|i18n">
                                    </app-icon>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="row.pod" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
                                    <div fxLayout="row" fxLayoutGap="10px" class="txt-p-16-4">
                                        <app-icon *ngIf="isDefined(row.pod.relevant_energy)" name="fal-plug"></app-icon>
                                        <div>
                                            {{ isDefined(row.pod.relevant_energy) && !keepYourSecrets ? (row.pod.relevant_energy|niceValue:'kWh') : '-' }}
                                        </div>
                                    </div>
                                    <div fxLayout="row" class="txt-p-16-4">
                                        {{
                                            isDefined(row.pod.incentivation.algorithm.performance) && !keepYourSecrets ?
                                                (row.pod.incentivation.algorithm.performance * 100|niceValue:'%') : '-'
                                        }}
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- absorbed energy cell - only for ALGORITHM_FANO -->
                        <ng-container *ngIf="algorithm === ALGORITHM_FANO" matColumnDef="absorbed_energy">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Absorbed energy between 8 and 18'|i18n }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="'The weight of POD absorption on total community absorptions between 8 and 18.'|i18n">
                                    </app-icon>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="row.pod" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
                                    <div fxLayout="row" fxLayoutGap="10px" class="txt-p-16-4">
                                        <app-icon *ngIf="isDefined(row.pod.incentivation.algorithm.working_hour_pod_absorbed_energy)"
                                                  name="fal-plug"></app-icon>
                                        <div>
                                            {{
                                                isDefined(row.pod.incentivation.algorithm.working_hour_pod_absorbed_energy) && !keepYourSecrets ?
                                                    (row.pod.incentivation.algorithm.working_hour_pod_absorbed_energy|niceValue:'kWh') : '-'
                                            }}
                                        </div>
                                    </div>
                                    <div fxLayout="row" class="txt-p-16-4">
                                        {{ !keepYourSecrets ? (getFanoAbsorptionParticipation(row.pod)|niceValue:'%') : '-' }}
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- performance incentive cell - only for ALGORITHM_VAI or ALGORITHM_CAPPED_VAI or ALGORITHM_FANO -->
                        <ng-container
                                *ngIf="algorithm === ALGORITHM_VAI || algorithm === ALGORITHM_CAPPED_VAI || algorithm === ALGORITHM_FANO"
                                matColumnDef="performance_incentive">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Performance incentive'|i18n }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="('Variable amount, computed for each POD based on member\'s performance'|i18n)">
                                    </app-icon>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div fxLayout="row" fxLayoutAlign="center center" *ngIf="row.pod" [ngClass]=cellTextColor>
                                    {{
                                        isDefined(row.pod.incentivation.algorithm.performance_revenue) && !keepYourSecrets ?
                                            (row.pod.incentivation.algorithm.performance_revenue|niceValue:'€':2: row.pod.incentivation.algorithm.performance_revenue < 0) : '-'
                                    }}
                                </div>
                            </td>
                        </ng-container>

                        <!-- fixed part cell - only for ALGORITHM_CAPPED_VAI or ALGORITHM_VAI-->
                        <ng-container *ngIf="algorithm === ALGORITHM_CAPPED_VAI || algorithm === ALGORITHM_VAI"
                                      matColumnDef="fixed_part">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Fixed part'|i18n }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="('Fixed amount received by the POD regardless of absorption.'|i18n)">
                                    </app-icon>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div [ngClass]=cellTextColor fxLayoutAlign="center" *ngIf="row.pod">
                                    {{
                                        isDefined(row.pod.incentivation.algorithm.fixed_revenue) && !keepYourSecrets ?
                                            (row.pod.incentivation.algorithm.fixed_revenue|niceValue:'€':2: row.pod.incentivation.algorithm.fixed_revenue < 0) : '-'
                                    }}
                                </div>
                            </td>
                        </ng-container>

                        <!-- member share cell - only for ALGORITHM_FANO-->
                        <ng-container *ngIf="algorithm === ALGORITHM_FANO" [matColumnDef]="MEMBERS_SHARE_COLUMN">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Member share'|i18n }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="('Amount allocated to the founding members.'|i18n)">
                                    </app-icon>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <ng-container *ngIf="row.pod">
                                    <div *ngIf="row.member.subject_classification === ECMemberSubjectClassification.FOUNDER &&
                                                isDefined(row.pod?.incentivation.algorithm.founder_percentage) &&
                                                !keepYourSecrets"
                                         fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                                        <div class="members-share-icon">
                                            <app-icon name="fal-sack-dollar"></app-icon>
                                        </div>
                                        <div [ngClass]=cellTextColor fxLayoutAlign="center">
                                            {{
                                                (row.pod.incentivation.algorithm.founder_percentage|niceValue:'€':2: row.pod.incentivation.algorithm.founder_percentage < 0)
                                            }}
                                        </div>
                                    </div>
                                    <div *ngIf="row.member.subject_classification !== ECMemberSubjectClassification.FOUNDER ||
                                                !isDefined(row.pod?.incentivation.algorithm.founder_percentage) ||
                                                keepYourSecrets"
                                         fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                                        <div [ngClass]=cellTextColor fxLayoutAlign="center">-</div>
                                    </div>
                                </ng-container>
                            </td>
                        </ng-container>

                        <!-- cap cell - only for ALGORITHM_CAPPED_VAI-->
                        <ng-container *ngIf="algorithm === ALGORITHM_CAPPED_VAI" matColumnDef="CAP">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'CAP'|i18n }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="('Maximum threshold of shared energy that can be incentivized'|i18n)">
                                    </app-icon>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="txt-p-14-7" fxLayoutAlign="center" *ngIf="row.pod">
                                    {{
                                        row.pod.redistribution && isDefined(row.pod.redistribution[CAP]) && !keepYourSecrets ?
                                            (row.pod.redistribution[CAP] * 100|niceValue:'%') : '-'
                                    }}
                                </div>
                            </td>
                        </ng-container>

                        <!-- mixed fixed cell - only for ALGORITHM_MIXED -->
                        <ng-container *ngIf="algorithm === ALGORITHM_MIXED"
                                      matColumnDef="mixed_fixed">
                            <th mat-header-cell *matHeaderCellDef class="width-15">
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Fixed amount'|i18n }}</div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div [ngClass]=cellTextColor fxLayout="row" fxLayoutAlign="center" *ngIf="row.pod"
                                     fxLayoutGap="12px">
                                    <div class="txt-p-14-4">{{ row.pod.redistribution.mixed_monthly|niceValue:'€':2: row.pod.redistribution.mixed_monthly < 0 }}{{ '/' + ('month'|i18n) }}</div>
                                    <div class="txt-p-14-7">{{ row.pod.redistribution.mixed_monthly * 12|niceValue:'€':2: row.pod.redistribution.mixed_monthly < 0 }}{{ '/' + ('year'|i18n) }}</div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- mixed percentage cell - only for ALGORITHM_MIXED -->
                        <ng-container *ngIf="algorithm === ALGORITHM_MIXED"
                                      matColumnDef="mixed_percentage">
                            <th mat-header-cell *matHeaderCellDef class="width-15">
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ '% fixed on the remaining'|i18n }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="('Percentage calculated on the remaining portion from the fixed amount redistribution'|i18n)">
                                    </app-icon>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div [ngClass]=cellTextColor fxLayout="row" fxLayoutAlign="center" fxLayoutGap="36px"
                                     *ngIf="row.pod">
                                    <div class="txt-p-14-4">{{ row.pod.redistribution.mixed_fixed * 100|niceValue:'%':2 }}</div>
                                    <div class="txt-p-14-7">{{ row.pod.incentivation.algorithm.fixed_revenue|niceValue:'€':2: row.pod.incentivation.algorithm.fixed_revenue < 0 }}</div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- mixed performance cell - only for ALGORITHM_MIXED -->
                        <ng-container *ngIf="algorithm === ALGORITHM_MIXED"
                                      matColumnDef="mixed_performance">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Performance'|i18n }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="('Amount calculated on the leftover remaining redistributable'|i18n)">
                                    </app-icon>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div [ngClass]=cellTextColor fxLayout="row" fxLayoutAlign="space-around center"
                                     fxLayoutGap="8px" *ngIf="row.pod">
                                    <div *ngIf="row.pod.redistribution.mixed_performance"
                                         fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px" fxFlex="50">
                                        <app-icon fxFlex="15" class="txt-s-14-4 primary-color" name="fal-check-circle"></app-icon>
                                        <app-icon fxFlex="15" class="txt-s-14-4" name="fal-plug"></app-icon>
                                        <div fxFlex="60" class="txt-p-14-4">{{ row.pod.relevant_energy|niceValue:'kWh' }}</div>
                                    </div>
                                    <div *ngIf="!row.pod.redistribution.mixed_performance"
                                         fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px" fxFlex="50">
                                        <app-icon fxFlex="15" class="txt-s-14-4" name="fal-times-circle"></app-icon>
                                        <div fxFlex="15"></div>
                                        <div fxFlex="60"></div>
                                    </div>
                                    <div class="txt-p-14-4">{{ row.pod.incentivation.algorithm.performance * 100|niceValue:'%' }}</div>
                                    <div class="txt-p-14-7">{{ row.pod.incentivation.algorithm.performance_revenue|niceValue:'€':2: row.pod.incentivation.algorithm.performance_revenue < 0 }}</div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- total cell -->
                        <ng-container matColumnDef="total">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <app-icon icon-color-h name="fal-euro-sign" class="small-icon"></app-icon>
                                    <div class="txt-h-16-7">{{ 'Total'|i18n }}</div>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [title]="(response.redistribution?.algorithm === ALGORITHM_THOUSANDTH ?
                                              'Incentive computed on the thousandth and the active POD stay over the period':
                                              'Total computed on the performance and the active POD stay over the period')|i18n">
                                    </app-icon>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="row.pod" [ngClass]=cellTextColor fxLayoutAlign="center">
                                    {{ keepYourSecrets ? '-' : row.pod.incentivation.revenue|niceValue:'€':2: row.pod.incentivation.revenue < 0 }}
                                </div>
                            </td>
                        </ng-container>

                        <!-- cap settings cell -->
                        <ng-container *ngIf="algorithm === ALGORITHM_CAPPED_VAI" matColumnDef="CAP_settings">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let row">
                                <button app-primary-button (click)="onClickEditCap(row.pod)" *ngIf="row.pod"
                                        [disabled]="!isWholeYear || !isUpdatable(entity) || !row.isConsumer || communityNotConfigured">
                                    <app-icon name="fal-pen" class="ml-10"></app-icon>
                                </button>
                            </td>
                        </ng-container>

                        <!-- virtual self-consumption cell - only for ALGORITHM_CONDO_OLD -->
                        <ng-container *ngIf="algorithm === ALGORITHM_CONDO_OLD" matColumnDef="virtual_self_consumption">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Virtual self-consumption'|i18n }}</div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="row.pod" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
                                    <div fxLayout="row" fxLayoutGap="10px" class="txt-p-16-4">
                                        <app-icon *ngIf="isDefined(row.pod.relevant_energy)" name="fal-plug"></app-icon>
                                        <div>
                                            {{
                                                isDefined(row.pod.relevant_energy) && !keepYourSecrets ?
                                                    (row.pod.relevant_energy|niceValue:'kWh') : '-'
                                            }}
                                        </div>
                                    </div>
                                    <div fxLayout="row" class="txt-p-16-4">
                                        {{ !keepYourSecrets ? (getAbsorptionParticipation(row.pod)|niceValue:'%') : '-' }}
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- tip fee cell - only for ALGORITHM_CONDO_OLD or ALGORITHM_CONDO_NEW (tip fee -> shared_energy_fee (for old), tip_fee (for new)) -->
                        <ng-container *ngIf="algorithm === ALGORITHM_CONDO_OLD || isCondomNew" matColumnDef="tip_fee">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ (isCondomNew ? 'Management fee' : 'TIP fee')|i18n }}</div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="isPodRow(row)" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
                                    <div *ngIf="algorithm === ALGORITHM_CONDO_OLD" class="txt-p-16-4 fee">
                                        {{
                                            isDefined(row.pod.incentivation.algorithm.shared_energy_fee) && !keepYourSecrets ?
                                                (-row.pod.incentivation.algorithm.shared_energy_fee|niceValue:'€':2:true) : '-'
                                        }}
                                    </div>
                                    <!-- for condo new, TIP fee is only available for POD holders -->
                                    <!-- TIP fee is also shown for SEU PODs (member treated as an effective HOLDER) -->
                                    <div *ngIf="isCondomNew && (getMemberPodRoles(row.pod).includes(ECMemberRelationType.HOLDER) || row.pod.seu)"
                                         class="txt-p-16-4 fee">
                                        {{
                                            isDefined(row.pod.incentivation.algorithm.tip_fee) && !keepYourSecrets ?
                                                (-row.pod.incentivation.algorithm.tip_fee|niceValue:'€':2:true) : '-'
                                        }}
                                    </div>
                                </div>
                                <!-- for condo new, TIP fee can be shown for property unit, if available -->
                                <div *ngIf="isOnlyMemberRow(row) && isCondomNew && row.propertyUnit?.seu"
                                     fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px"
                                     class="txt-p-16-4 fee">
                                    {{
                                        isDefined(row.propertyUnit.incentivation.algorithm?.tip_fee) && !keepYourSecrets ?
                                            (-row.propertyUnit.incentivation.algorithm.tip_fee|niceValue:'€':2:true) : '-'
                                    }}
                                </div>
                            </td>
                        </ng-container>

                        <!-- withdrawal fee cell - only for ALGORITHM_CONDO_OLD (withdrawal fee -> rei_fee) -->
                        <ng-container *ngIf="algorithm === ALGORITHM_CONDO_OLD" matColumnDef="withdrawal_fee">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'Withdrawal fee'|i18n }}</div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="row.pod" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
                                    <div class="txt-p-16-4 fee">
                                        {{
                                            isDefined(row.pod.incentivation.algorithm.rei_fee) && !keepYourSecrets ?
                                                (-row.pod.incentivation.algorithm.rei_fee|niceValue:'€':2:true) : '-'
                                        }}
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- tip benefit cell - only for ALGORITHM_CONDO_OLD or ALGORITHM_CONDO_NEW (tip benefit -> tip_benefit) -->
                        <ng-container *ngIf="algorithm === ALGORITHM_CONDO_OLD || isCondomNew" matColumnDef="tip_benefit">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ 'TIP benefit'|i18n }}</div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="isPodRow(row)" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
                                    <!-- for condo new, TIP benefit is only available for POD holders -->
                                    <!-- TIP benefit is also shown for SEU PODs (member treated as an effective HOLDER) -->
                                    <div *ngIf="algorithm === ALGORITHM_CONDO_OLD || (isCondomNew && (getMemberPodRoles(row.pod).includes(ECMemberRelationType.HOLDER) || row.pod.seu))"
                                         class="txt-p-16-4 benefit">
                                        {{
                                            isDefined(row.pod.incentivation.algorithm.tip_benefit) && !keepYourSecrets ?
                                                (row.pod.incentivation.algorithm.tip_benefit|niceValue:'€') : '-'
                                        }}
                                    </div>
                                </div>
                                <!-- for condo new, TIP benefit can be shown for property unit, if available -->
                                <div *ngIf="isOnlyMemberRow(row) && isCondomNew && row.propertyUnit?.seu"
                                     fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px"
                                     class="txt-p-16-4 benefit">
                                    {{
                                        isDefined(row.propertyUnit.incentivation.algorithm?.tip_benefit) && !keepYourSecrets ?
                                            (row.propertyUnit.incentivation.algorithm.tip_benefit|niceValue:'€') : '-'
                                    }}
                                </div>
                            </td>
                        </ng-container>

                        <!-- cacv benefit cell - only for ALGORITHM_CONDO_OLD (cacv benefit -> cacv_benefit) -->
                        <ng-container *ngIf="algorithm === ALGORITHM_CONDO_OLD" matColumnDef="cacv_benefit">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7" [innerHTML]="'{0} benefit'|i18n:CACV_STRING"></div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="row.pod" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
                                    <div class="txt-p-16-4 benefit">
                                        {{
                                            isDefined(row.pod.incentivation.algorithm.cacv_benefit) && !keepYourSecrets ?
                                                (row.pod.incentivation.algorithm.cacv_benefit|niceValue:'€') : '-'
                                        }}
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- withdrawal benefit cell - only for ALGORITHM_CONDO_OLD or ALGORITHM_CONDO_NEW (withdrawal benefit -> sold_energy_benefit) -->
                        <ng-container *ngIf="algorithm === ALGORITHM_CONDO_OLD || isCondomNew" matColumnDef="withdrawal_benefit">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div *ngIf="algorithm === ALGORITHM_CONDO_OLD || isCondomNew"
                                         class="txt-h-16-7">
                                        {{ 'Sold energy benefit'|i18n }}
                                    </div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="row.pod && algorithm === ALGORITHM_CONDO_OLD"
                                     fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px" class="txt-p-16-4 benefit">
                                    {{
                                        isDefined(row.pod.incentivation.algorithm.sold_energy_benefit) && !keepYourSecrets ?
                                            (row.pod.incentivation.algorithm.sold_energy_benefit|niceValue:'€') : '-'
                                    }}
                                </div>
                                <!-- for condo new, sold energy benefit is only available for owners -->
                                <div *ngIf="isOnlyMemberRow(row) && isCondomNew"
                                     fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px" class="txt-p-16-4 benefit">
                                    {{
                                        isDefined(row.propertyUnit?.incentivation.algorithm?.sold_energy_benefit) && !keepYourSecrets ?
                                            (row.propertyUnit.incentivation.algorithm.sold_energy_benefit|niceValue:'€') : '-'
                                    }}
                                </div>
                            </td>
                        </ng-container>

                        <!-- total benefits cell - only for ALGORITHM_CONDO_OLD or ALGORITHM_CONDO_NEW (total benefit -> tip_benefit + cacv_benefit (only for old) + sold_energy_benefit (only for property unit)) -->
                        <ng-container *ngIf="algorithm === ALGORITHM_CONDO_OLD || isCondomNew" matColumnDef="total_benefit">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <div class="txt-h-16-7">{{ '€ Total benefits'|i18n }}</div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <!-- pod -->
                                <div *ngIf="row.pod" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
                                    <div *ngIf="algorithm === ALGORITHM_CONDO_OLD" class="txt-p-18-7 benefit">
                                        {{
                                            isDefined(row.pod.incentivation.algorithm.sold_energy_benefit) && !keepYourSecrets ?
                                                (getOldCondoTotalBenefit(row.pod.incentivation.algorithm)|niceValue:'€') : '-'
                                        }}
                                    </div>
                                    <div *ngIf="isCondomNew" class="txt-p-18-7 benefit">
                                        {{
                                            isDefined(row.pod.incentivation.algorithm.tip_benefit) && !keepYourSecrets ?
                                                (getNewCondoPodTotalBenefit(row.pod.incentivation.algorithm)|niceValue:'€') : '-'
                                        }}
                                    </div>
                                </div>
                                <!-- member -->
                                <div *ngIf="!row.pod && row.member && isCondomNew"
                                     fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px"
                                     class="txt-p-18-7 benefit">
                                    {{
                                        isDefined(row.propertyUnit?.incentivation.algorithm?.sold_energy_benefit) && !keepYourSecrets ?
                                            (getNewCondoPropertyUnitTotalBenefit(row.propertyUnit.incentivation.algorithm)|niceValue:'€') : '-'
                                    }}
                                </div>
                            </td>
                        </ng-container>

                        <!-- POD calculation details cell -->
                        <ng-container *ngIf="algorithm === ALGORITHM_VAI ||
                                             algorithm === ALGORITHM_CAPPED_VAI ||
                                             algorithm === ALGORITHM_FANO ||
                                             algorithm === ALGORITHM_CONDO_OLD ||
                                             algorithm === ALGORITHM_CONDO_NEW ||
                                             algorithm === ALGORITHM_THOUSANDTH ||
                                             algorithm === ALGORITHM_MIXED"
                                      matColumnDef="details">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let row">
                                <button *ngIf="showDetailsButton(row)" app-small-ghost-button
                                        (click)="showDetailsDialog(row)"
                                        [disabled]="detailsButtonDisabled || keepYourSecrets || !(row.isConsumer || (isOnlyMemberRow(row) && row.propertyUnit?.seu))"
                                        class="search">
                                    <app-icon name="fal-search-plus" class="ml-10"></app-icon>
                                </button>
                            </td>
                        </ng-container>

                        <!-- Subheader if the chosen algorithm is MIXED_ALGORITHM -->
                        <ng-container matColumnDef="subHeader1">
                            <th mat-header-cell *matHeaderCellDef></th>
                        </ng-container>
                        <ng-container matColumnDef="subHeader2">
                            <th mat-header-cell *matHeaderCellDef></th>
                        </ng-container>
                        <ng-container matColumnDef="subHeader3">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center">
                                    <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="12px">
                                        <div class="txt-h-14-4">{{ '€/' + ('month'|i18n) }}</div>
                                        <div class="txt-h-14-7">{{ '€/' + ('year'|i18n) }}</div>
                                    </div>
                                </div>
                            </th>
                        </ng-container>
                        <ng-container matColumnDef="subHeader4">
                            <th mat-header-cell *matHeaderCellDef class="width-20">
                                <div fxLayout="row wrap" fxLayoutAlign="center center">
                                    <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="12px">
                                        <div class="txt-h-14-4">{{ ('Value'|i18n) + ' %' }}</div>
                                        <div class="txt-h-14-7">{{ 'Corresponding amount'|i18n }}</div>
                                    </div>
                                </div>
                            </th>
                        </ng-container>
                        <ng-container matColumnDef="subHeader5">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row wrap" fxLayoutAlign="center center">
                                    <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="12px">
                                        <div fxLayout="row" class="txt-h-14-4" fxLayoutAlign="start center" fxLayoutGap="6px">
                                            <div>{{ 'Shared energy per capita'|i18n }}</div>
                                            <app-icon icon-color-h name="fas-info-circle"
                                                      [title]="('POD weight on the total sharing of the community'|i18n)">
                                            </app-icon>
                                        </div>
                                        <div class="txt-h-14-7">{{ 'Amount'|i18n }}</div>
                                    </div>
                                </div>
                            </th>
                        </ng-container>
                        <ng-container matColumnDef="subHeader6">
                            <th mat-header-cell *matHeaderCellDef></th>
                        </ng-container>
                        <ng-container matColumnDef="subHeader7">
                            <th mat-header-cell *matHeaderCellDef></th>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <!-- Special sub header in case of mixed algorithm -->
                        <ng-container *ngIf="algorithm === ALGORITHM_MIXED">
                            <tr mat-header-row
                                *matHeaderRowDef="['subHeader1', 'subHeader2', 'subHeader3', 'subHeader4', 'subHeader5', 'subHeader6', 'subHeader7']"
                                class="sub-header"></tr>
                        </ng-container>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                            class="app-row app-border-upper-row"
                            [ngClass]="{'app-border-upper-row': !row.pod && (!isCondomNew || !row.member)}">
                        </tr>
                    </table>
                    <mat-divider></mat-divider>
                </ng-container>
                <div *ngIf="rows.total === 0" fxLayout="row" fxLayoutAlign="center">
                    {{ 'No members found'|i18n }}
                </div>
            </ng-container>
            <!-- end of table -->
            <mat-paginator #paginator app-paginator class="member-paginator"
                           [ngClass]="{'collapsed': !rows || rows.total === 0}"
                           [length]="rows?.total" [pageSize]="DEFAULT_PAGE_SIZE"
                           [pageSizeOptions]="DEFAULT_PAGE_SIZES">
            </mat-paginator>
        </div>
    </ng-container>

    <!-- end of table section -->
    <div fxLayoutAlign="end center" *ngIf="isExportSupported()">
        <button *ngIf="response && isWholeYear"
                app-ghost-button (click)="onClickExportEconomicsToFile()"
                [disabled]="templateIsDownloading || isNoAlgorithm || !response?.redistribution">
            <app-icon name="fal-file-excel"></app-icon>
            {{ (isCondomNewStrategy ? 'Export to CSV' : 'Export to Excel')|i18n }}
        </button>
    </div>
</div>

<ng-template #newCondoExportEconomics let-close="close">
    <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="30px" class="dialog-box">
        <div>{{ 'Select the CSV file you want to download:'|i18n }}</div>
        <mat-radio-group [(ngModel)]="exportCondoNewLayout" fxLayout="column" fxLayoutGap="10px" class="ml-10">
            <mat-radio-button app-radio-button [value]="EC_FILE_EXPORT_CONDO_NEW_LAYOUT_1" class="txt-p-14-4">
                {{ EC_FILE_EXPORT_CONDO_NEW_LAYOUT_1|exportCondoNewLayouts }}
            </mat-radio-button>
            <mat-radio-button app-radio-button [value]="EC_FILE_EXPORT_CONDO_NEW_LAYOUT_2" class="txt-p-14-4">
                {{ EC_FILE_EXPORT_CONDO_NEW_LAYOUT_2|exportCondoNewLayouts }}
            </mat-radio-button>
            <mat-radio-button app-radio-button [value]="EC_FILE_EXPORT_CONDO_NEW_LAYOUT_3" [disabled]="isLayout3Disabled" class="txt-p-14-4">
                {{ EC_FILE_EXPORT_CONDO_NEW_LAYOUT_3|exportCondoNewLayouts }}
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-30 mb-20" fxLayoutAlign="center" fxLayoutGap="20px">
        <button app-ghost-button [mat-dialog-close]="false">
            {{ 'Cancel'|i18n }}
        </button>
        <button app-primary-button [mat-dialog-close]="true" (click)="close(exportCondoNewLayout)">
            {{ 'Confirm'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #chooseAlgorithm let-data let-close="close">
    <app-ec-algorithm
            [date]="singleDate"
            [response]="response"
            [availableAlgorithms]=availableAlgorithms
            [entity]="entity"
            [billingPeriod]="billingPeriod"
            [billingPeriodCfg]="billingPeriodCfg"
            [timeZone]="timeZone"
            [hierarchyEntity]="entity"
            (selected)="close($event)">
    </app-ec-algorithm>
</ng-template>

<ng-template #loadingEconomics>
    <div fxLayout="column" fxLayoutAlign="space-around center">
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
            <mat-spinner app-spinner diameter="20"></mat-spinner>
            <span class="pl-8">{{ 'Loading data'|i18n }}...</span>
        </div>
        <div *ngIf="showComputationWarning" fxLayout="row" fxLayoutAlign="center center"
             fxLayoutGap="30px" economics-warning class="mt-30 padding-14">
            <app-icon icon-color-w name="fas-info-circle"></app-icon>
            <div>{{ 'We are recalculating the economics data due to an updated configuration parameter.'|i18n }}</div>
        </div>
        <div class="mt-12"></div>
    </div>
</ng-template>

<ng-template #unviewableEntity>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{ 'Insufficient permissions to view this resource'|i18n }}
    </div>
</ng-template>

<ng-template #incentiveCalculation let-data>

    <div *ngIf="data.algorithm === ALGORITHM_THOUSANDTH" fxLayout="column" class="p-30">
        <span class="txt-h-24-7 mb-20">{{ 'Understanding the incentive computation'|i18n }}</span>
        <span class="txt-s-16-4 mb-10">{{ 'The resulting amount for each member\'s POD is primarily based on his condominium thousandth.'|i18n }}</span>
        <div class="txt-s-16-4">{{ 'Additional parameters that indirectly define the amount assignable to the POD are:'|i18n }}</div>
        <ul>
            <li class="txt-s-16-4 mb-4">{{ 'the POD\'s time as "active" during the selected period'|i18n }}</li>
            <li class="txt-s-16-4 mb-4">{{ 'any change in the total number of active POD during the selected period'|i18n }}</li>
            <li class="txt-s-16-4 mb-4">{{ 'any change in a POD\'s value in thousandths during the selected period'|i18n }}</li>
            <li class="txt-s-16-4">{{ 'the eventual sum of the thousandths configured as less than 1000'|i18n }}</li>
        </ul>
        <div fxLayout="row" fxLayoutAlign="center" mat-dialog-actions class="dialog-actions">
            <button app-primary-button [mat-dialog-close]="true">
                {{ 'Ok'|i18n }}
            </button>
        </div>
    </div>

    <div *ngIf="data.algorithm === ALGORITHM_VAI || data.algorithm === ALGORITHM_CAPPED_VAI || data.algorithm === ALGORITHM_FANO || data.algorithm === ALGORITHM_CONDO_OLD || data.algorithm === ALGORITHM_CONDO_NEW"
         fxLayout="column" class="p-30">
        <div fxLayoutAlign="center" class="txt-h-24-7 mb-20">{{ 'Understanding the incentive computation'|i18n }}</div>
        <div *ngIf="data.algorithm === ALGORITHM_VAI || data.algorithm === ALGORITHM_CAPPED_VAI"
             class="txt-s-16-4 mb-10">
            {{ 'The redistribution amount displayed in the table is relative only to consumer utilities and is intended to be understood as net.'|i18n }}
        </div>
        <div *ngIf="data.algorithm === ALGORITHM_FANO" class="txt-s-16-4 mb-10">
            {{ 'The redistribution amount displayed in the table is relative only to consumer utilities and is intended to be understood as net, taking into account the shares allocated to founding members and the social fund.'|i18n }}
        </div>
        <div *ngIf="data.algorithm === ALGORITHM_CONDO_OLD" class="txt-s-16-4 mb-10">
            {{ 'The redistribution amount displayed in the table is relative only to holder consumer utilities'|i18n }}
        </div>
        <div *ngIf="data.algorithm === ALGORITHM_CONDO_NEW" class="txt-s-16-4 mb-10">
            {{ 'The redistribution amount displayed in the table is relative to holder and owner consumer utilities'|i18n }}
        </div>
        <div *ngIf="data.algorithm !== ALGORITHM_CONDO_OLD && data.algorithm !== ALGORITHM_CONDO_NEW" class="txt-s-16-4 mb-10">
            {{ 'The resulting amount for each POD is computed based on its energy contribution through absorption.'|i18n }}
        </div>
        <div *ngIf="data.algorithm === ALGORITHM_CAPPED_VAI" class="txt-s-16-4 mb-10">
            {{ 'Moreover, for each POD an incentive maximum threshold can be defined for the withdrawal of energy from the POD. When the threshold is reached, the exceeding incentive will be distributed over the remaining PODs.'|i18n }}
        </div>
        <div class="txt-s-16-4">{{ 'Additional parameters that indirectly define the amount assignable to the POD are:'|i18n }}</div>
        <ul>
            <li class="txt-s-16-4 mb-4">{{ 'the consumer POD\'s time as "active" during the selected period'|i18n }}</li>
            <li class="txt-s-16-4 mb-4">{{ 'any change in the total number of active consumer POD during the selected period'|i18n }}</li>
            <li class="txt-s-16-4 mb-4">{{ 'any change in the POD\'s energy profile'|i18n }}</li>
            <li class="txt-s-16-4 mb-4">{{ 'any changes made to the parameters of the algorithm itself during the selected period'|i18n }}</li>
            <li *ngIf="data.algorithm === ALGORITHM_CAPPED_VAI" class="txt-s-16-4 mb-4">
                {{ 'a missing CAP threshold for a specific pod'|i18n }}
            </li>
            <li *ngIf="data.algorithm === ALGORITHM_CAPPED_VAI" class="txt-s-16-4 mb-4">
                {{ 'the redistribution of the amount that exceeds the CAP of a POD over the others'|i18n }}
            </li>
        </ul>
        <div fxLayout="row" fxLayoutAlign="center" mat-dialog-actions class="dialog-actions">
            <button app-primary-button [mat-dialog-close]="true">
                {{ 'Ok'|i18n }}
            </button>
        </div>
    </div>

    <div *ngIf="data.algorithm === ALGORITHM_MIXED" fxLayout="column" class="p-30">
        <div class="txt-h-16-7 mb-10">{{ 'Understanding the incentive computation'|i18n }}</div>
        <div class="txt-s-16-4 mb-10">{{ 'The resulting amount for each member\'s POD is primarily based on his condominium thousandth.'|i18n }}</div>
        <div class="txt-s-16-4">{{ 'Additional parameters that indirectly define the amount assignable to the POD are:'|i18n }}</div>
        <ul>
            <li class="txt-s-16-4 mb-4">{{ 'the POD\'s time as "active" during the selected period'|i18n }}</li>
            <li class="txt-s-16-4 mb-4">{{ 'any change in the total number of active POD during the selected period'|i18n }}</li>
            <li class="txt-s-16-4 mb-4">{{ 'any change in a POD\'s energetic profile'|i18n }}</li>
            <li class="txt-s-16-4">{{ 'eventual variations to the algorithm\'s parameters during the selected period'|i18n }}</li>
        </ul>
        <div class="txt-p-16-4">{{ 'To configure the redistribution through the Excel file, you have to:'|i18n }}</div>
        <ul>
            <li class="txt-p-16-4 mb-4">{{ 'defined a fixed monthly amount'|i18n }}</li>
            <li class="txt-p-16-4 mb-4">{{ 'redistribute the eventual remaining amount with fixed percentages for each POD'|i18n }}</li>
            <li class="txt-p-16-4">{{ 'decide, for each POD, whether or not to allocate any additional allowance based on per capita sharing. This assignation has to be present of at least one utility.'|i18n }}</li>
        </ul>
        <div fxLayout="row" fxLayoutAlign="center" mat-dialog-actions class="dialog-actions">
            <button app-primary-button [mat-dialog-close]="true">
                {{ 'Ok'|i18n }}
            </button>
        </div>
    </div>

</ng-template>

<ng-template #ecWaitingForApproval>
    <div fxLayout="column" class="p-30" fxLayoutAlign="center center">
        <div class="txt-h-24-7">{{ 'Community waiting for activation'|i18n }}</div>
        <app-icon icon-color-h name="fal-clock" fxFlex="60" class="clock-icon mt-30 mb-30"></app-icon>
        <ng-container *ngIf="inactiveEc">
            <div class="txt-s-16-4">{{ 'This community has no activation date yet.'|i18n }}</div>
            <div class="txt-s-16-4">{{ 'As soon as the community is activated, you will see economic and energy data here.'|i18n }}</div>
        </ng-container>
        <ng-container *ngIf="!inactiveEc">
            <div class="txt-s-16-4">{{ 'This community will be activated by {0}.'|i18n:(billingPeriodCfg.pastDate|i18nDate) }}</div>
            <div class="txt-s-16-4">{{ 'Economic data will be available from that day.'|i18n }}</div>
        </ng-container>
        <div mat-dialog-actions class="dialog-actions mt-30">
            <button app-primary-button [mat-dialog-close]="true">
                {{ 'Ok'|i18n }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #changeCap let-data let-close="close">
    <div fxLayout="column" fxLayoutAlign="center center">
        <div class="app-dialog-background" fxLayout="row" fxLayoutAlign="center center">
            <app-cap-selector [date]="singleDate"
                              [pod]="data.pod"
                              (capThreshold)="data.threshold = $event"
                              (valid)="data.valid = $event">
            </app-cap-selector>
        </div>
        <div mat-dialog-actions class="dialog-actions" fxLayoutAlign="center" fxLayoutGap="20px" class="mt-20 mb-20">
            <button app-ghost-button [mat-dialog-close]="true" (click)="close(resetCap(data.pod,singleDate))">
                {{ 'Reset'|i18n }}
            </button>
            <button app-ghost-button [mat-dialog-close]="false">
                {{ 'Cancel'|i18n }}
            </button>
            <button app-primary-button [mat-dialog-close]="true" [disabled]="!data.valid"
                    (click)="close(data.threshold)">
                {{ 'Confirm'|i18n }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #details let-data>
    <div fxLayout="column" fxLayoutGap="20px" class="p-20">
        <div class="txt-h-24-7">{{ data.member.subjectName }}</div>
        <div class="txt-h-18-7">{{ data.isPod ? data.member.pod.pod : data.puName }}</div>
        <div *ngIf="data.isPod"
                fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
            <div class="txt-s-16-4">{{ data.podType|i18n }}</div>
            <div class="txt-p-16-4 box">{{ data.podName }}</div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly start" class="mt-40">

            <!-- 1 personal sharing -->
            <div *ngIf="algorithm !== ALGORITHM_MIXED" fxLayout="column"
                 [fxFlex]="algorithm === ALGORITHM_THOUSANDTH ? 30 : standardWidth">
                <div class="txt-h-14-7 title">{{ '1. ' + ('Personal sharing'|i18n) }}</div>
                <div fxLayout="row" fxLayoutAlign="start center" class="tile">
                    <app-icon icon-color-h name="fal-plug" class="mr-10"></app-icon>
                    <div fxLayout="column">
                        <div class="txt-p-14-7">{{ data.relevantEnergy|niceValue:'kWh' }}</div>
                        <div class="txt-p-12-4">{{ ('on '|i18n) + (data.absorbedEnergy|niceValue:'kWh') }}</div>
                    </div>
                    <apx-chart
                            [series]="sharingChart.series"
                            [chart]="sharingChart.chart"
                            [legend]="sharingChart.apexLegends"
                            [labels]="sharingChart.labels"
                            [colors]="sharingChart.colors"
                            [dataLabels]="sharingChart.dataLabels"
                            [plotOptions]="sharingChart.plotOptions"
                            [tooltip]="sharingChart.tooltip"
                            [subtitle]="sharingChart.subtitle"
                            fxFlex="30"
                            class="ml-25">
                    </apx-chart>
                </div>
                <div class="txt-p-12-4">
                    {{ 'Absorption that became shared energy on the total personal absorption.'|i18n }}
                </div>
            </div>

            <!-- ALGORITHM_VAI or ALGORITHM_CAPPED_VAI or ALGORITHM_FANO or ALGORITHM_CONDO_OLD or ALGORITHM_CONDO_NEW -->
            <ng-container
                    *ngIf="(algorithm === ALGORITHM_VAI || algorithm === ALGORITHM_CAPPED_VAI || algorithm === ALGORITHM_FANO || algorithm === ALGORITHM_CONDO_OLD || algorithm === ALGORITHM_CONDO_NEW)">

                <!-- 2 ALGORITHM_VAI or ALGORITHM_CAPPED_VAI or ALGORITHM_CONDO_OLD or ALGORITHM_CONDO_NEW participation in community sharing -->
                <div *ngIf="algorithm === ALGORITHM_VAI || algorithm === ALGORITHM_CAPPED_VAI|| algorithm === ALGORITHM_CONDO_OLD || algorithm === ALGORITHM_CONDO_NEW"
                     fxLayout="column" [fxFlex]="standardWidth">
                    <div class="txt-h-14-7 title">{{ '2. ' + ('Participation in community sharing'|i18n) }}</div>
                    <div fxLayout="row" fxLayoutAlign="start center" class="tile">
                        <app-icon icon-color-h name="fal-plug" class="mr-10"></app-icon>
                        <div fxLayout="column">
                            <div class="txt-p-14-7">{{ (data.isPod ? getAbsorptionParticipation(data.member.pod) : getPuAbsorptionParticipation(data.member.propertyUnit))|niceValue:'%' }}</div>
                            <div class="txt-p-12-4">
                                {{(data.relevantEnergy|niceValue:'kWh') + (' on '|i18n) + (response.shared_energy|niceValue:'kWh') }}
                            </div>
                        </div>
                        <apx-chart
                                [series]="participationChart.series"
                                [chart]="participationChart.chart"
                                [legend]="participationChart.apexLegends"
                                [labels]="participationChart.labels"
                                [colors]="participationChart.colors"
                                [dataLabels]="participationChart.dataLabels"
                                [plotOptions]="participationChart.plotOptions"
                                [tooltip]="participationChart.tooltip"
                                fxFlex="30"
                                class="ml-20">
                        </apx-chart>
                    </div>
                    <div *ngIf="algorithm !== ALGORITHM_CONDO_OLD && algorithm !== ALGORITHM_CONDO_NEW" class="txt-p-12-4">
                        {{ 'Weight of POD absorption on total community sharing.'|i18n }}
                    </div>
                    <div *ngIf="algorithm === ALGORITHM_CONDO_OLD || algorithm === ALGORITHM_CONDO_NEW" class="txt-p-12-4">
                        {{ (data.isPod ? 'POD weight on the total shared energy of the community' :  'Withdrawal weight on the total shared energy of the community')|i18n }}
                    </div>
                </div>

                <!-- 2 ALGORITHM_FANO participation in community sharing -->
                <div *ngIf="algorithm === ALGORITHM_FANO" fxLayout="column" [fxFlex]="standardWidth">
                    <div class="txt-h-14-7 title">{{ '2. ' + ('Participation in community'|i18n) }}</div>
                    <div fxLayout="row" fxLayoutAlign="start center" class="tile">
                        <app-icon icon-color-h name="fal-plug" class="mr-10"></app-icon>
                        <div fxLayout="column">
                            <div class="txt-p-14-7">{{ getFanoAbsorptionParticipation(data.member.pod)|niceValue:'%' }}</div>
                            <div class="txt-p-12-4">
                                {{
                                    (data.member.pod.incentivation.algorithm.working_hour_pod_absorbed_energy|niceValue:'kWh') +
                                    (' on '|i18n) +
                                    (data.member.pod.incentivation.algorithm.working_hour_community_absorbed_energy|niceValue:'kWh')
                                }}
                            </div>
                        </div>
                        <apx-chart
                                [series]="fanoParticipationChart.series"
                                [chart]="fanoParticipationChart.chart"
                                [legend]="fanoParticipationChart.apexLegends"
                                [labels]="fanoParticipationChart.labels"
                                [colors]="fanoParticipationChart.colors"
                                [dataLabels]="fanoParticipationChart.dataLabels"
                                [plotOptions]="fanoParticipationChart.plotOptions"
                                [tooltip]="fanoParticipationChart.tooltip"
                                fxFlex="30"
                                class="ml-20">
                        </apx-chart>
                    </div>
                    <div class="txt-p-12-4">
                        {{ 'The weight of POD absorption on total community absorptions between 8 and 18.'|i18n }}
                    </div>
                </div>

                <!-- 3 ALGORITHM_CAPPED_VAI cap -->
                <div *ngIf="algorithm === ALGORITHM_CAPPED_VAI" fxLayout="column" fxFlex="17">
                    <div class="txt-h-14-7 title">{{ '3. ' + ('CAP'|i18n) }}</div>
                    <div fxLayout="row" fxLayoutAlign="start center" class="tile-darker">
                        <app-icon icon-color-h name="fal-plug"></app-icon>
                        <div class="txt-p-14-7 ml-10">{{ data.member.pod.redistribution[CAP] * 100|niceValue:'%' }}</div>
                        <div class="txt-p-12-4 ml-10">{{ ' of sharing from absorption'|i18n }}</div>
                    </div>
                    <div class="txt-p-12-4">
                        {{ 'Maximum contribution threshold that can be accumulated from consumer POD in one hour.'|i18n }}
                    </div>
                </div>

                <!-- 3 ALGORITHM_VAI or 3 ALGORITHM_FANO or 4 ALGORITHM_CAPPED_VAI performance incentive -->
                <div *ngIf="algorithm === ALGORITHM_VAI || algorithm === ALGORITHM_CAPPED_VAI || algorithm === ALGORITHM_FANO"
                     fxLayout="column" [fxFlex]="standardWidth">
                    <div class="txt-h-14-7 title">
                        {{ (algorithm === ALGORITHM_VAI || algorithm === ALGORITHM_FANO ? '3. ' : '4. ') + ('Performance incentive'|i18n) }}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" class="tile-darker">
                        <app-icon icon-color-h name="fal-plug"></app-icon>
                        <div class="txt-p-14-7 ml-10">{{ data.member.pod.incentivation.algorithm.performance_revenue|niceValue:'€':2 : data.member.pod.incentivation.algorithm.performance_revenue < 0 }}</div>
                    </div>
                    <div class="txt-p-14-4">
                        <div *ngIf="algorithm === ALGORITHM_VAI">
                            {{ 'Redistributable performance incentive * participation in community sharing.'|i18n }}
                        </div>
                        <div *ngIf="algorithm === ALGORITHM_CAPPED_VAI">
                            {{ 'Redistributable performance incentive * min (participation in community sharing; CAP) + any exceeding CAP from other consumers.'|i18n }}
                        </div>
                        <div *ngIf="algorithm === ALGORITHM_FANO">
                            {{ 'Redistributable performance incentive * participation in community absorption between 8 and 18.'|i18n }}
                        </div>
                        <b *ngIf="algorithm !== ALGORITHM_FANO">{{ 'The computation is performed on an hourly basis.'|i18n }}</b>
                        <b *ngIf="algorithm === ALGORITHM_FANO">{{ 'The computation is performed on a monthly basis.'|i18n }}</b>
                    </div>
                </div>

                <!-- 4 ALGORITHM_VAI or 4 ALGORITHM_FANO or 5 ALGORITHM_CAPPED_VAI total -->
                <div *ngIf="algorithm === ALGORITHM_VAI || algorithm === ALGORITHM_FANO" fxLayout="column" [fxFlex]="standardWidth">
                    <div class="txt-h-14-7 title">
                        {{ (algorithm === ALGORITHM_VAI || algorithm === ALGORITHM_FANO ? '4. ' : '5. ') + ('Total'|i18n) }}
                    </div>
                    <div fxLayout="column" fxLayoutGap="10px" class="tile-darker align-right">
                        <div class="txt-p-14-7">
                            {{ data.member.pod.incentivation.algorithm.performance_revenue|niceValue:'€':2:data.member.pod.incentivation.algorithm.performance_revenue < 0 }}
                        </div>
                        <div class="txt-p-14-7">+</div>
                        <div class="txt-p-14-7">
                            {{
                                algorithm === ALGORITHM_FANO ?
                                    (data.member.pod.incentivation.algorithm.founder_percentage|niceValue:'€':2:data.member.pod.incentivation.algorithm.founder_percentage < 0) :
                                    (data.member.pod.incentivation.algorithm.fixed_revenue|niceValue:'€':2:data.member.pod.incentivation.algorithm.fixed_revenue < 0)
                            }}
                        </div>
                        <div class="txt-p-14-4">{{ (algorithm === ALGORITHM_FANO ? 'founding members share' : 'fixed part')|i18n }}</div>
                        <div class="line" fxFlex></div>
                        <div class="txt-p-18-7">{{ data.member.pod.incentivation.revenue|niceValue:'€':2: data.member.pod.incentivation.revenue < 0 }}</div>
                        <div fxLayout="column" fxLayoutAlign="space-around end">
                            <div class="txt-h-14-7" fxLayoutAlign="center center"
                                 [ngClass]="{'overwrite-color': data.member.pod.incentivation.algorithm.gse}">
                            <span *ngIf="!communityNotConfigured">
                                {{ data.member.pod.incentivation.algorithm.absorption_revenue|niceValue: '€': 2 : data.member.pod.incentivation.algorithm.absorption_revenue < 0 }}
                            </span>
                                <span *ngIf="communityNotConfigured">
                                {{ '€ -' }}
                            </span>
                            </div>
                            <div class="txt-h-14-4" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured">
                                {{ ('from TIP: '|i18n) + (data.member.pod.incentivation.tip|niceValue: '€': 2: data.member.pod.incentivation.tip < 0) }}
                            </span>
                                <span *ngIf="communityNotConfigured">
                                {{ ('from TIP: '|i18n) + '€ -' }}
                            </span>
                            </div>
                            <div class="txt-h-14-4" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured"
                                  [innerHTML]="('from {0}: '|i18n:CACV_STRING)
                                  + (data.member.pod.incentivation.cacv|niceValue: '€': 2 : data.member.pod.incentivation.cacv < 0)"></span>
                                <span *ngIf="communityNotConfigured"
                                      [innerHTML]="('from {0}: '|i18n:CACV_STRING)
                                  + '€ -'"></span>
                            </div>
                            <div class="txt-h-14-4 margin-top-minus-3" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured">
                                {{ ('from withdrawal: '|i18n) + (data.member.pod.incentivation.rei|niceValue: '€': 2: data.member.pod.incentivation.rei < 0) }}
                            </span>
                                <span *ngIf="communityNotConfigured">
                                {{ ('from withdrawal: '|i18n) + '€ -' }}
                            </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 3 ALGORITHM_CONDO_OLD or ALGORITHM_CONDO_NEW benefits -->
                <div *ngIf="algorithm === ALGORITHM_CONDO_OLD || algorithm === ALGORITHM_CONDO_NEW" fxLayout="column"
                     [fxFlex]="standardWidth">
                    <div class="txt-h-14-7 title">
                        {{ '3. ' + ('Benefits'|i18n) }}
                    </div>
                    <div fxLayout="column" fxLayoutGap="10px" class="tile-darker align-right">
                        <div class="txt-p-14-7">
                            {{ data.isPod ?
                            (data.member.pod.incentivation.algorithm.tip_benefit|niceValue:'€':2:data.member.pod.incentivation.algorithm.tip_benefit < 0) :
                            (data.member.propertyUnit.incentivation.algorithm.tip_benefit|niceValue:'€':2:data.member.propertyUnit.incentivation.algorithm.tip_benefit < 0)
                            }}
                        </div>
                        <div class="txt-h-14-4">{{ 'TIP benefit'|i18n }}</div>
                        <ng-container *ngIf="algorithm === ALGORITHM_CONDO_OLD">
                            <div class="txt-p-14-7">+</div>
                            <div class="txt-p-14-7">
                                {{ data.member.pod.incentivation.algorithm.cacv_benefit|niceValue:'€':2:data.member.pod.incentivation.algorithm.cacv_benefit < 0 }}
                            </div>
                            <div class="txt-h-14-4" [innerHTML]="'{0} benefit'|i18n:CACV_STRING"></div>
                            <div class="txt-p-14-7">+</div>
                            <div class="txt-p-14-7">
                                {{ data.member.pod.incentivation.algorithm.sold_energy_benefit|niceValue:'€':2:data.member.pod.incentivation.algorithm.sold_energy_benefit < 0 }}
                            </div>
                            <div class="txt-h-14-4">{{ 'Sold energy benefit'|i18n }}</div>
                            <div class="line" fxFlex></div>
                            <div class="txt-p-14-7">
                                {{ getOldCondoTotalBenefit(data.member.pod.incentivation.algorithm)|niceValue:'€':2:getOldCondoTotalBenefit(data.member.pod.incentivation.algorithm) < 0 }}
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <!-- ALGORITHM_THOUSANDTH -->
            <ng-container *ngIf="algorithm === ALGORITHM_THOUSANDTH">
                <!-- 2 ALGORITHM_THOUSANDTH condominium thousandths -->
                <div fxLayout="column" fxFlex="30">
                    <div class="txt-h-14-7 title">{{ '2. ' + ('Condominium thousandths'|i18n) }}</div>
                    <div fxLayoutAlign="start start" class="tile txt-p-14-7">
                        <div class="mb-20 txt-p-18-7">
                            {{ data.member.pod.redistribution[THOUSANDTHS] + '/1000' }}
                        </div>
                    </div>
                </div>
                <!-- 3 ALGORITHM_THOUSANDTH total -->
                <div fxLayout="column" fxFlex="30">
                    <div class="txt-h-14-7 title">{{ '3. ' + ('Total'|i18n) }}</div>
                    <div fxLayout="column" fxLayoutAlign="space-around end" fxLayoutGap="18px"
                         class="tile-darker txt-p-18-7">
                        <div class="mb-20 txt-p-18-7">
                            {{ data.member.pod.incentivation.revenue|niceValue:'€':2 : data.member.pod.incentivation.revenue < 0 }}
                        </div>
                        <div fxLayout="column" fxLayoutAlign="space-around end">
                            <div class="txt-h-14-7" fxLayoutAlign="center center"
                                 [ngClass]="{'overwrite-color': data.member.pod.incentivation.algorithm.gse}">
                            <span *ngIf="!communityNotConfigured">
                                {{ data.member.pod.incentivation.algorithm.absorption_revenue|niceValue: '€': 2:  data.member.pod.incentivation.algorithm.absorption_revenue < 0 }}
                            </span>
                                <span *ngIf="communityNotConfigured">
                                {{ '€ -' }}
                            </span>
                            </div>
                            <div class="txt-h-14-4" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured">
                                {{ ('from TIP: '|i18n) + (data.member.pod.incentivation.tip|niceValue: '€': 2: data.member.pod.incentivation.tip < 0) }}
                            </span>
                                <span *ngIf="communityNotConfigured">
                                {{ ('from TIP: '|i18n) + '€ -' }}
                            </span>
                            </div>
                            <div class="txt-h-14-4" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured"
                                  [innerHTML]="('from {0}: '|i18n:CACV_STRING)
                                  + (data.member.pod.incentivation.cacv|niceValue: '€': 2: data.member.pod.incentivation.cacv < 0)"></span>
                                <span *ngIf="communityNotConfigured"
                                      [innerHTML]="('from {0}: '|i18n:CACV_STRING)
                                  + '€ -'"></span>
                            </div>
                            <div class="txt-h-14-4 margin-top-minus-3" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured">
                                {{ ('from withdrawal: '|i18n) + (data.member.pod.incentivation.rei|niceValue: '€': 2: data.member.pod.incentivation.rei < 0) }}
                            </span>
                                <span *ngIf="communityNotConfigured">
                                {{ ('from withdrawal: '|i18n) + '€ -' }}
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- ALGORITHM_MIXED -->
            <ng-container *ngIf="algorithm === ALGORITHM_MIXED">
                <div fxLayout="row" fxLayoutGap="24px">
                    <div fxFlex="4"></div>
                    <!-- 1 ALGORITHM MIXED - Fixed Amount -->
                    <div fxLayout="column" fxFlex="30">
                        <div class="txt-h-16-7 title">{{ '1. ' + ('Fixed amount'|i18n) }}</div>
                        <div fxLayoutAlign="start start" class="tile txt-p-14-7 set-height-90" fxLayout="column" fxLayoutGap="10px">
                            <div class="txt-p-16-4">
                                {{ data.member.pod.redistribution.mixed_monthly|niceValue:'€':2: data.member.pod.redistribution.mixed_monthly < 0 }}{{ '/' + ('month'|i18n) }}
                            </div>
                            <div class="txt-p-16-7">
                                {{ data.member.pod.redistribution.mixed_monthly * 12|niceValue:'€':2: data.member.pod.redistribution.mixed_monthly < 0 }}{{ '/' + ('year'|i18n) }}
                            </div>
                        </div>
                        <div class="mt-12 txt-p-14-4">
                            <div>{{ 'Amount assigned to the POD arbitrarily, it repeats on every month of the year.'|i18n }}</div>
                        </div>
                    </div>
                    <!-- 2 ALGORITHM MIXED - Variable percentage -->
                    <div fxLayout="column" fxFlex="30">
                        <div class="txt-h-16-7 title">{{ '2. ' + ('Variable percentage on the remaining amount'|i18n) }}</div>
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="tile txt-p-14-7 set-height-90">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="18px">
                                <app-icon name="fal-coins" class="txt-s-18-4"></app-icon>
                                <div fxLayout="column">
                                    <div class="txt-p-16-7">{{ data.member.pod.redistribution.mixed_fixed * 100|niceValue:'%':2 }}</div>
                                    <div class="txt-p-14-4">{{ data.member.pod.incentivation.algorithm.fixed_revenue|niceValue:'€':2: data.member.pod.incentivation.algorithm.fixed_revenue < 0 }}</div>
                                </div>
                            </div>
                            <div class="txt-s-12-4">
                                <apx-chart
                                        [series]="fixedAmountChart.series"
                                        [chart]="fixedAmountChart.chart"
                                        [legend]="fixedAmountChart.apexLegends"
                                        [labels]="fixedAmountChart.labels"
                                        [colors]="fixedAmountChart.colors"
                                        [dataLabels]="fixedAmountChart.dataLabels"
                                        [plotOptions]="fixedAmountChart.plotOptions"
                                        [tooltip]="fixedAmountChart.tooltip"
                                        [subtitle]="fixedAmountChart.subtitle"
                                        fxFlex="52"
                                        class="ml-25">
                                </apx-chart>
                            </div>
                        </div>
                        <div class="mt-12 txt-p-14-4">
                            <div>{{ 'Fixed percentage of the optional remaining total incentive, assigned to the POD arbitrarily.'|i18n }}</div>
                        </div>
                    </div>
                    <!-- 3 ALGORITHM MIXED - Performance incentive -->
                    <div fxLayout="column" fxFlex="30">
                        <div class="txt-h-16-7 title">{{ '3. ' + ('Performance incentive from sharing'|i18n) }}</div>
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="tile txt-p-14-7 set-height-90">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="18px">
                                <app-icon name="fal-plug" class="txt-s-16-4"></app-icon>
                                <div fxLayout="column">
                                    <div *ngIf="!data.member.pod.redistribution.mixed_performance"
                                         class="txt-s-16-4" fxLayout="row" fxLayoutGap="6px">
                                        <app-icon name="fal-times-circle"></app-icon>
                                        <span>{{ 'No'|i18n }}</span>
                                    </div>
                                    <div *ngIf="data.member.pod.redistribution.mixed_performance"
                                         class="txt-s-16-4 primary-color" fxLayout="row" fxLayoutGap="6px">
                                        <app-icon name="fal-check-circle"></app-icon>
                                        <span>{{ 'Yes'|i18n }}</span>
                                    </div>
                                    <div *ngIf="!data.member.pod.redistribution.mixed_performance" class="txt-p-14-4">{{ '€ -' }}</div>
                                    <div *ngIf="data.member.pod.redistribution.mixed_performance" class="txt-p-14-4">
                                        {{ data.member.pod.incentivation.algorithm.performance_revenue|niceValue:'€':2: data.member.pod.incentivation.algorithm.performance_revenue < 0 }}
                                    </div>
                                </div>
                            </div>
                            <div class="txt-s-12-4">
                                <apx-chart
                                        [series]="sharingPerformanceChart.series"
                                        [chart]="sharingPerformanceChart.chart"
                                        [legend]="sharingPerformanceChart.apexLegends"
                                        [labels]="sharingPerformanceChart.labels"
                                        [colors]="sharingPerformanceChart.colors"
                                        [dataLabels]="sharingPerformanceChart.dataLabels"
                                        [plotOptions]="sharingPerformanceChart.plotOptions"
                                        [tooltip]="sharingPerformanceChart.tooltip"
                                        [subtitle]="sharingPerformanceChart.subtitle"
                                        fxFlex="40"
                                        class="ml-25">
                                </apx-chart>
                            </div>
                        </div>
                        <div class="mt-12 txt-p-14-4" fxLayout="column" fxLayoutGap="12px">
                            <div fxLayout="column">
                                <div>{{ 'Redistributable based on performance * participation to the absorption of the community.'|i18n }}</div>
                                <div>{{ 'The computation is executed by the hour.'|i18n }}</div>
                            </div>
                            <div>{{ 'This component can be assigned to the POD arbitrarily, if there is any remaining incentive from steps 1 and 2.'|i18n }}</div>
                        </div>
                    </div>
                    <!-- 4 ALGORITHM MIXED - Total -->
                    <div fxLayout="column" fxFlex="30">
                        <div class="txt-h-16-7 title">{{ '4. ' + ('Total based on period'|i18n) }}</div>
                        <div fxLayout="column" fxLayoutAlign="start end" class="tile-darker txt-p-18-7" fxLayoutGap="12px">
                            <div class="txt-p-16-7" fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="start end">
                                <div>{{ data.member.pod.incentivation.algorithm.fixed_monthly_revenue|niceValue:'€':2: data.member.pod.incentivation.algorithm.fixed_monthly_revenue < 0 }}</div>
                                <div>{{ '+' }}</div>
                                <div>{{ data.member.pod.incentivation.algorithm.fixed_revenue|niceValue:'€':2: data.member.pod.incentivation.algorithm.fixed_revenue < 0 }}</div>
                                <div *ngIf="data.member.pod.redistribution.mixed_performance">{{ '+' }}</div>
                                <div *ngIf="data.member.pod.redistribution.mixed_performance">{{ data.member.pod.incentivation.algorithm.performance_revenue|niceValue:'€':2: data.member.pod.incentivation.algorithm.performance_revenue < 0 }}</div>
                            </div>
                            <mat-divider [style]="'width: 100%'"></mat-divider>
                            <div class="mt-8 txt-p-24-7">
                                {{ data.member.pod.incentivation.revenue|niceValue:'€':2: data.member.pod.incentivation.revenue < 0 }}
                            </div>
                            <div fxLayout="column" fxLayoutAlign="space-around end">
                                <div class="txt-h-14-7" fxLayoutAlign="center center"
                                     [ngClass]="{'overwrite-color': data.member.pod.incentivation.algorithm.gse}">
                            <span *ngIf="!communityNotConfigured">
                                {{ data.member.pod.incentivation.algorithm.absorption_revenue|niceValue: '€': 2 :  data.member.pod.incentivation.algorithm.absorption_revenue < 0 }}
                            </span>
                                    <span *ngIf="communityNotConfigured">
                                {{ '€ -' }}
                            </span>
                                </div>
                                <div class="txt-h-14-4" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured">
                                {{ ('from TIP: '|i18n) + (data.member.pod.incentivation.tip|niceValue: '€': 2: data.member.pod.incentivation.tip < 0) }}
                            </span>
                                    <span *ngIf="communityNotConfigured">
                                {{ ('from TIP: '|i18n) + '€ -' }}
                            </span>
                                </div>
                                <div class="txt-h-14-4" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured"
                                  [innerHTML]="('from {0}: '|i18n:CACV_STRING)
                                  + (data.member.pod.incentivation.cacv|niceValue: '€': 2: data.member.pod.incentivation.cacv < 0)"></span>
                                    <span *ngIf="communityNotConfigured"
                                          [innerHTML]="('from {0}: '|i18n:CACV_STRING)
                                  + '€ -'"></span>
                                </div>
                                <div class="txt-h-14-4 margin-top-minus-3" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured">
                                {{ ('from withdrawal: '|i18n) + (data.member.pod.incentivation.rei|niceValue: '€': 2: data.member.pod.incentivation.rei < 0) }}
                            </span>
                                    <span *ngIf="communityNotConfigured">
                                {{ ('from withdrawal: '|i18n) + '€ -' }}
                            </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div fxLayoutAlign="center" class="mt-20 mb-50">
        <button app-primary-button [mat-dialog-close]="false">
            {{ 'Close'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>
